import { useEffect, useState, useReducer, useCallback } from 'react'
import Button from '../../general/Button'
import getSortItems from '../../../functions/getSortItems'
import naturalCompare from '../../../functions/naturalCompare'
import EditBrandsListItem from './EditBrandsListItem'

const getSortBrandItems = (itemsKeys, moviesData, mappingsData) => itemsKeys.sort(function(a, b) {
    if(mappingsData[a] === null && mappingsData[b] === null) {
        return 0
    } else if (mappingsData[b] === null) {
        return 1;
    } else if (mappingsData[a] === null) {
        return -1;
    } else {
        return naturalCompare(
            moviesData[a].titleDisplay || moviesData[a].title,
            moviesData[b].titleDisplay || moviesData[b].title
        )
    }
})

const EditBrandsList = ({movies, moviesOrder, metaMovies, mappings, brands, onUpdateBrand}) => {

    const [sortList, setSortList] = useState('noBrands')
    const [forceUpdate, forceUpdateSortList] = useReducer(x => x + 1, 0);
    const [sortedBrands, setSortedBrands] = useState([])
    const [sortedMovies, setSortedMovies] = useState([])
    const moviesKeys = Object.keys(movies)
    const metaMoviesKeys = Object.keys(metaMovies)
    let i = 0

    useEffect(() => {
        const sortedBrandPks = getSortItems('name', 'alphabetical', Object.keys(brands), brands)
        setSortedBrands(sortedBrandPks.map(pk => brands[pk]))
    }, [brands])

    useEffect(() => {
        if('noBrands' === sortList)  {
            setSortedMovies(getSortBrandItems(moviesKeys, movies, mappings))
        } else if('alphabetical' === sortList) {
            setSortedMovies(getSortItems('titleDisplay', 'alphabetical', moviesKeys, movies, 'title'))
        } else if ('newest' === sortList) {
            setSortedMovies(getSortItems('created_at', 'date', metaMoviesKeys, metaMovies))
        } else if ('sorting' === sortList) {
            setSortedMovies(moviesOrder)
        }
    }, [sortList, forceUpdate])

    return (
        <div className="edit-brands-list">
            <div className="gap-20">
                <h3  className="gap-20 title-list text-regular">Liste sortieren nach:</h3>
                <Button
                    className={"button-small button-sort-list" + ('noBrands' === sortList ? " active" : "")}
                    transId="no_brand"
                    hideText={false}
                    onClick={() => {
                        setSortList('noBrands')        
                        'noBrands' === sortList && forceUpdateSortList()
                    }}
                />
                <Button
                    className="button-small button-sort-list"
                    transId="alphabetical"
                    hideText={false}
                    disabled={'alphabetical' === sortList}
                    onClick={() => setSortList('alphabetical')}
                />
                <Button
                    className="button-small button-sort-list"
                    transId="newest"
                    hideText={false}
                    disabled={'newest' === sortList}
                    onClick={() => setSortList('newest')}
                />
                <Button
                    className="button-small button-sort-list"
                    transId="movie_sorting"
                    hideText={false}
                    disabled={'sorting' === sortList}
                    onClick={() => setSortList('sorting')}
                />
            </div>

            <ul className="list-main">
                {sortedMovies.map(moviePk => {

                    if(movies.hasOwnProperty(moviePk)) {
                        i++

                        return <EditBrandsListItem
                            key={moviePk}
                            itemData={movies[moviePk]}
                            evenOddClass={0 === i % 2 ? 'odd' : 'even'}
                            sortedBrandsList={sortedBrands}
                            brandValue={mappings[moviePk]}
                            onUpdateBrand={onUpdateBrand(moviePk)}
                        />

                    } else {
                        return ''
                    }
                })}
            </ul>
        </div>
    )
}

export default EditBrandsList